import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from '@/pages/HomePage';
import NoContentPage from '@/pages/NoContentPage';
import '@/App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/whitepaper" element={<NoContentPage route="whitepaper" />} />
          <Route path="/roadmap" element={<NoContentPage route="roadmap" />} />
          <Route path="/docs" element={<NoContentPage route="docs" />} />
          <Route path="/faq" element={<NoContentPage route="faq" />} />
          <Route path="/press" element={<NoContentPage route="press" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;